import { FunctionComponent, useState } from 'react';
import React from 'react';
import styles from './NotificationUserItem.module.scss';
import { formatDistance } from 'date-fns';
import { arMA, enUS } from 'date-fns/locale';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { NotificationImg, UserImg } from 'app/assets/images/icons';
interface Props {
  userName: string;
  text: string;
  time?: string;
  image?: string;
  withBigText?: boolean;
  usageWithAlart?: boolean;
  user_id?: number | string;
}

const NotificationUserItem: FunctionComponent<Props> = ({
  userName,
  text,
  time,
  image,
  withBigText,
  usageWithAlart,
  user_id,
}) => {
  const dirc = getFromLocalStorage('LNG');
  // setDir(dir);
  const [dir] = useState<string | null>(dirc);

  return (
    <div
      className={`${
        usageWithAlart ? styles.usageWithAlart : styles.NotificationUserItem
      }
      notificatiosUserName`}
    >
      {image ? (
        <div
          className={`${withBigText ? styles.bigImage : ''} ${styles.image} `}
        >
          <img src={image} alt={`${userName}-image`} />
        </div>
      ) : user_id ? (
        <UserImg
          style={{
            width: withBigText ? 64 : 35,
            height: withBigText ? 64 : 35,
          }}
        />
      ) : (
        <NotificationImg
          style={{
            width: withBigText ? 64 : 35,
            height: withBigText ? 64 : 35,
          }}
        />
      )}
      <div className={`notifications-flex  ${withBigText ? styles.text : ''}`}>
        <div
          style={{
            color: '#ACACAC',
            padding: 0,
            textTransform: 'inherit',
            whiteSpace: 'break-spaces',
            fontSize: `${withBigText} ? 16px : 10px`,
            textAlign: 'start',
            maxWidth: withBigText ? 600 : 260,
          }}
          className="notifications-b"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />

        <div>
          {formatDistance(new Date(time ? time : ''), new Date(), {
            locale: dir === 'ar' ? arMA : enUS,
          })}
        </div>
      </div>
    </div>
  );
};

export default NotificationUserItem;
